import { macroCTV } from './ctv';

export const MACRO_TEMPLATES = [macroCTV];

export * from './ctv';
